/**
 * Requires component computed property:
 * operatorCode
 */

import { OPERATOR_CONFIGS } from '@/utils/constants/drs/operators'

const RETAILER_TOKEN_TOOLTIP = `
    Token to unikalny ciąg znaków, uwierzytelniający punkt zbiórki.
    <br/>Można go uzyskać, kontaktując się bezpośrednio z operatorem 
    (+48 455 455 221 lub <u>kontakt.pk@polskakaucja.pl</u>)
`

const CP_ID_TOOLTIP = `
    Numer punktu zbiórki to unikalny identyfikator Twojego sklepu.
    <br/>Znajdziesz go w Panelu Operatora.
`

export default {
    computed: {
        operatorConfig() {
            return OPERATOR_CONFIGS[this.operatorCode] || {}
        },

        cpIdFormats() {
            return this.operatorConfig.cpIdFormats || []
        },

        cpIdRegexes() {
            return this.cpIdFormats.map(format => new RegExp(
                '^' + format
                    .replace(/#/g, '\\d')
                    .replace(/\*/g, '[a-zA-Z0-9]') + '$'
            ))
        },

        cpIdPlaceholder() {
            return this.cpIdFormats.join(' lub ').replace(/[#*]/g, 'x')
        },

        cpIdMask() {
            const masks = this.cpIdFormats.map(format => format.replaceAll('#', '9'))
            return masks.length === 1 ? masks[0] : masks
        },

        cpIdFeedback() {
            return `Niepoprawny format identyfikatora sklepu (musi być w formacie ${this.cpIdPlaceholder})`
        },

        cpIdMaxLength() {
            return this.cpIdFormats.length
                ? Math.max(...this.cpIdFormats.map(format => format.length))
                : null
        },

        isRetailerTokenRequired() {
            return !!this.operatorConfig.retailerTokenRequired
        },

        retailerTokenTooltip() {
            return RETAILER_TOKEN_TOOLTIP
        },

        cpIdTooltip() {
            return CP_ID_TOOLTIP
        }
    },

    methods: {
        isValidCpId(value) {
            return !!value && this.cpIdRegexes.some(regex => regex.test(value))
        }
    }
}
